module.exports = __webpack_public_path__ + "img/7m.1d463b4e.png";